import React from 'react';
import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { toast } from 'react-toastify';
import { isNil } from 'lodash';
import { useStoreState } from 'easy-peasy';

import InfoUpdate from './InfoUpdate';
import client from '../../../../utils/apolloClient';
import TimingUpdate from './TimingUpdate';
import DeliveryAddressUpdate from './DeliveryAddressUpdate';
import DineinUpdate from './DineinUpdate';

const adminUpdateMenuOrderMutation = gql`
  mutation adminUpdateMenuOrderMutation($input: AdminMenuOrderInput) {
    admin_update_menu_order(input: $input) {
      menu_order_id
      scheduled_date_time
      estimated_completion_time
      table_number
      no_of_attendees
      contact {
        contact_name
        contact_phone
      }
      address {
        type
        address_line_1
        address_line_2
        city
        state
        post_code
        country
        delivery_option {
          type
          caption
        }
      }
      error {
        code
        description
      }
    }
  }
`;

const UpdateOrderModal = ({
  order,
  isActiveUpdateOrderModal,
  setActiveUpdateOrderModal,
  type,
  setOrder,
}) => {
  const { userId } = useStoreState(state => state.auth);
  const [
    adminUpdateMenuOrder,
    { loading: adminUpdateMenuOrderLoading },
  ] = useMutation(adminUpdateMenuOrderMutation, {
    client: client.clientPrivate,
    onCompleted: ({ admin_update_menu_order }) => {
      if (!isNil(admin_update_menu_order.error)) {
        admin_update_menu_order.error.map(item =>
          toast.error(item.description),
        );
      } else {
        if (type === 'INFORMATION') {
          const { contact } = admin_update_menu_order;
          setOrder(prev => ({ ...prev, contact }));
        } else if (type === 'SCHEDULE_DATE_TIME') {
          const {
            scheduled_date_time,
            estimated_completion_time,
          } = admin_update_menu_order;
          setOrder(prev => ({
            ...prev,
            scheduled_date_time,
            estimated_completion_time,
          }));
        } else if (type === 'ADDRESS') {
          const { address } = admin_update_menu_order;
          setOrder(prev => ({ ...prev, address }));
        } else if (type === 'DINEIN') {
          const { table_number, no_of_attendees } = admin_update_menu_order;
          setOrder(prev => ({ ...prev, table_number, no_of_attendees }));
        }

        setActiveUpdateOrderModal(false);
      }
    },
  });

  if (type === 'INFORMATION') {
    return (
      <InfoUpdate
        isActive={isActiveUpdateOrderModal}
        order={order}
        onClose={() => setActiveUpdateOrderModal(false)}
        adminUpdateMenuOrder={adminUpdateMenuOrder}
        adminUpdateMenuOrderLoading={adminUpdateMenuOrderLoading}
        userId={userId}
      />
    );
  }

  if (type === 'SCHEDULE_DATE_TIME') {
    return (
      <TimingUpdate
        isActive={isActiveUpdateOrderModal}
        order={order}
        onClose={() => setActiveUpdateOrderModal(false)}
        adminUpdateMenuOrder={adminUpdateMenuOrder}
        adminUpdateMenuOrderLoading={adminUpdateMenuOrderLoading}
        userId={userId}
      />
    );
  }

  if (type === 'ADDRESS') {
    return (
      <DeliveryAddressUpdate
        isActive={isActiveUpdateOrderModal}
        order={order}
        onClose={() => setActiveUpdateOrderModal(false)}
        adminUpdateMenuOrder={adminUpdateMenuOrder}
        adminUpdateMenuOrderLoading={adminUpdateMenuOrderLoading}
        userId={userId}
      />
    );
  }

  if (type === 'DINEIN') {
    return (
      <DineinUpdate
        isActive={isActiveUpdateOrderModal}
        order={order}
        onClose={() => setActiveUpdateOrderModal(false)}
        adminUpdateMenuOrder={adminUpdateMenuOrder}
        adminUpdateMenuOrderLoading={adminUpdateMenuOrderLoading}
        userId={userId}
      />
    );
  }
  return <></>;
};

export default UpdateOrderModal;
